module.exports = __webpack_public_path__ + "gatoTaza.png?ee83af7e68e9684dcc6dfa2d30600024";